export default [
  "Napęd",
  "Kontrola Jazdy",
  "Widok 360",
  "Bezpieczeństwo",
  "Audio",
  "Wyposażenie wnętrza"
];
